import { Component, OnInit } from '@angular/core';
import {TaxasDeEntregaCalculadasService} from "../../services/taxas-de-entrega-calculadas.service";
import {process, State} from "@progress/kendo-data-query";
import {DataStateChangeEvent, PageChangeEvent} from "@progress/kendo-angular-grid";
import {ConstantsService} from "../../fidelidade/ConstantsService";
import {HighlightPipe} from "../../pipes/highlight.pipe";

@Component({
  selector: 'app-tela-taxas-de-entregas-calculadas',
  templateUrl: './tela-taxas-de-entregas-calculadas.component.html',
  styleUrls: ['./tela-taxas-de-entregas-calculadas.component.scss'],
  providers: [HighlightPipe]
})
export class TelaTaxasDeEntregasCalculadasComponent implements OnInit {
  view: any;
  gridState: State = {
    sort: [],
    skip: 0,
    take: 10
  };
  carregando = false;
  carregandoMais = false;
  empresa: any;
  public windowTop = 100;
  public windowLeft = 50;
  public altura = 0;
  exibindoMapa: boolean;
  taxaSelecionada: any;
  Math = Math;
  filtroAtual: string = 'todos';
  termoBusca: string = '';
  filtroDatas = { inicio: null as Date | null, fim: null as Date | null };

  constructor(private constantsService: ConstantsService, private taxasDeEntregaCalculadasService: TaxasDeEntregaCalculadasService) {

  }

  ngOnInit(): void {
    this.constantsService.empresa$.subscribe( (empresa) => {
      if( !empresa ) {
        return;
      }

      this.empresa = empresa;

      this.carregueTaxas();
    });
  }

  public onPageChange(e: PageChangeEvent): void {
    this.carregueTaxas();
  }

  aplicarFiltro(filtro: string): void {
    this.filtroAtual = filtro;
    this.gridState.skip = 0;
    this.carregueTaxas();
  }

  aplicarBusca(): void {
    this.gridState.skip = 0;
    this.carregueTaxas();
  }

  formatarData(data: Date): string {
    if (!data) return '';
    const d = new Date(data);
    return d.toISOString().slice(0, 10);
  }

  carregueTaxas() {
    this.carregando = true;
    const dataInicial = this.filtroDatas.inicio ? this.formatarData(this.filtroDatas.inicio) : '';
    const dataFinal = this.filtroDatas.fim ? this.formatarData(this.filtroDatas.fim) : '';
    
    this.taxasDeEntregaCalculadasService.liste(
      this.gridState.skip, 
      this.gridState.take, 
      this.filtroAtual, 
      this.termoBusca,
      dataInicial,
      dataFinal
    ).then( (resposta) => {
      const origem = this.empresa.latitudeLongitude;
      for( const taxa of resposta.taxas ) {
        const destino = taxa.localizacao;
        const url = `https://www.google.com/maps/dir/?api=1&origin=${origem}&destination=${destino}&travelmode=driving`;
        taxa.linkMapa = url;
      }

      this.view = {
        data: resposta.taxas,
        total: resposta.total
      };
      this.carregando = false;
    });
  }

  public onStateChange(state: State) {
    this.gridState = state;
  }

  exibaMapa(taxa) {
    this.exibindoMapa = true;
    if( taxa.fazEntrega ) {
      this.taxaSelecionada = {
        localizacao: taxa.localizacao,
        msg: "Dentro da área de entrega: " + new Intl.NumberFormat('pt-BR',
          {style: 'currency', currency: 'BRL'}).format(taxa.valor)
      };
    } else {
      this.taxaSelecionada = {
        localizacao: taxa.localizacao,
        msg: taxa.erro
      };
    }

    return false;
  }

  fecharTelaMapa() {
    this.exibindoMapa = false;
  }

  carregarMais() {
    this.gridState.skip += this.gridState.take;
    this.carregandoMais = true;
    const dataInicial = this.filtroDatas.inicio ? this.formatarData(this.filtroDatas.inicio) : '';
    const dataFinal = this.filtroDatas.fim ? this.formatarData(this.filtroDatas.fim) : '';
    
    this.taxasDeEntregaCalculadasService.liste(
      this.gridState.skip, 
      this.gridState.take, 
      this.filtroAtual, 
      this.termoBusca,
      dataInicial,
      dataFinal
    ).then( (resposta) => {
      const origem = this.empresa.latitudeLongitude;
      for( const taxa of resposta.taxas ) {
        const destino = taxa.localizacao;
        const url = `https://www.google.com/maps/dir/?api=1&origin=${origem}&destination=${destino}&travelmode=driving`;
        taxa.linkMapa = url;
      }

      if (resposta.taxas && resposta.taxas.length > 0) {
        this.view.data.push(...resposta.taxas);
      }

      this.view.total = resposta.total;

      this.carregandoMais = false;
    });
  }
}
